import React from 'react';
import NumberFormat from 'react-number-format';
/**
 * CustomNumber.
 *
 * @param {NumberProps} props number's props
 * @returns {React.FC<NumberProps>} CustomNumber.
 */
export var CustomNumber = function (options) {
    var DecimalFormatter = function (value, separator) {
        return (React.createElement(React.Fragment, null,
            value.split(separator)[0] + separator,
            React.createElement("small", null, value.split(separator)[1])));
    };
    return (React.createElement(NumberFormat, { value: options.amount, displayType: 'text', fixedDecimalScale: true, decimalScale: 2, thousandSeparator: options.thousandSeparator, decimalSeparator: options.decimalSeparator, renderText: function (value) { return React.createElement(React.Fragment, null, DecimalFormatter(value, options.decimalSeparator)); } }));
};
//# sourceMappingURL=CustomNumber.js.map